<script lang="ts" setup>
import { ButtonSize, ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import MImageLoader from '@/components/molecules/forms/ImageLoader.vue'
import ADecorEllipse1 from '~/components/atoms/decor/Ellipse1.vue'
import ADecorMobileEllipse1 from '~/components/atoms/decor/MobileEllipse1.vue'
import { DefaultImage, HomeDefaultImages } from '~/static/enums/image/default-images'

const emit = defineEmits<{
  (e: 'image-selected', file: File): void
  (e: 'default-image-selected', image: DefaultImage): void
}>()

const changeImage = (file: File): void => {
  emit('image-selected', file)
}

const selectDefaultImage = (image: DefaultImage) => {
  emit('default-image-selected', image)
}
</script>

<template>
  <section class="hero">
    <div class="container-lg">
      <div class="hero__inner">
        <div class="row">
          <div class="fs-cards">
            <NuxtImg
              src="/home/first-screen.webp"
              alt="Шаблоны карточки с инфографикой для маркетплейсов в Магви"
              fetchpriority="high"
              sizes="256px 991px:400px 1199px:540px"
              densities="x1 x2"
              width="1106"
              height="1143"
              style="height: auto; aspect-ratio: 1106 / 1143;"
              preload
            />
          </div>
          <div class="col-12 col-lg-8 col-xl-6">
            <h1 class="hero__title">
              Создайте карточки с&nbsp;инфографикой<br> для маркетплейсов
            </h1>
            <p class="d-flex mb-1 mb-sm-2 fs-5">
              <BootstrapIconCheck2 class="me-2 my-1 icon-size-24 flex-shrink-0" />
              Бесплатный онлайн-конструктор
            </p>
            <p class="d-flex mb-1 mb-sm-2 fs-5">
              <BootstrapIconCheck2 class="me-2 my-1 icon-size-24 flex-shrink-0" />
              Удаление и создание фона при помощи нейросетей
            </p>
            <p class="d-flex mb-32 fs-5">
              <BootstrapIconCheck2 class="me-2 my-1 icon-size-24 flex-shrink-0" />
              5 000 000 иконок для оформления товара
            </p>
            <MImageLoader
              v-slot="scope"
              @change="changeImage"
            >
              <AButton
                :button-style="ButtonStyle.Primary"
                @click="scope.loadImage"
                :button-size="ButtonSize.Large"
                class="btn-load mobile-w-100"
              >
                Загрузить фото товара
              </AButton>
            </MImageLoader>

            <div class="choose-img">
              <p class="fs-6 mb-1">
                или выберите одну из этих:
              </p>
              <div>
                <NuxtImg
                  format="webp"
                  v-for="(image, index) in HomeDefaultImages()"
                  class="home-img cursor-pointer"
                  :key="index"
                  :src="image.smallUrl"
                  :srcset="image.retinaUrl + ' 2x'"
                  :alt="image.alt"
                  fetchpriority="hight"
                  preload
                  @click="selectDefaultImage(image)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="fs-ellipse">
          <ADecorEllipse1 class="d-none d-lg-block" />
          <ADecorMobileEllipse1 class="d-block d-lg-none" />
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.hero {
  position: relative;

  &__inner {
    position: relative;
    padding: rem(100px) 0 rem(10px);

    @include media-breakpoint-down(lg) {
      padding: rem(20px) 0 rem(20px);
    }
  }

  &__title {
    font-size: rem(50px);
    line-height: 110%;
    margin-bottom: rem(20px);

    @include media-breakpoint-down(md) {
      font-size: rem(28px);
      line-height: 120%;
    }
  }

  .home-img {
    width: rem(48px);
    height: rem(48px);

    &:not(:last-child) {
      margin-right: rem(9px);
    } 
  }

  .choose-img {
    width: rem(219px);
    text-align: center;
    margin: rem(12px) auto 0;

    @include media-breakpoint-up(sm) {
      margin: rem(12px) 0 0 rem(31px);
    }
  }

  .btn-load {
    @include media-breakpoint-up(sm) {
      width: 280px;
    }
  }
}

.fs-cards {
  max-width: rem(280px);

  @include media-breakpoint-up(lg) {
    position: absolute;
    right: 0;
    top: calc(50% + 20px);
    transform: translateY(-50%);
    max-width: rem(400px);
    max-height: rem(413px);
    padding: 0;
  }

  @include media-breakpoint-up(xl) {
    max-width: rem(540px);
    max-height: rem(558px);
    padding: 0;
  }

  img {
    aspect-ratio: 1106 / 1143;
    width: 100%;
    height: 100%;
  }
}

.fs-ellipse {
  position: absolute;
  width: 960px;
  height: 935px;
  top: -311px;
  left: -361px;
  z-index: -1;

  @include media-breakpoint-up(lg) {
    width: 800px;
    height: 767px;
    top: -240px;
    left: auto;
    right: -60px;
  }
  
  @include media-breakpoint-up(xl) {
    width: 1104px;
    height: 1058px;
    top: -242px;
    right: -283px;
  }
}
</style>
